import { css } from '@emotion/react';

export const shortTextStyles = ({ textTransform, color }) => css`
  text-transform: ${textTransform};
  font-size: 14px;
  color: ${color};
`;
